<div class=" mail-main-container d-flex gap-2 p-4">
<div class="left-container d-flex flex-column gap-2 p-4" >
    <div class="user d-flex justify-content-between ">
        <div class="viewed-message d-flex justify-content-center align-items-center"><div class="viewwed-circle "></div></div> <div class="d-flex flex-column"> <div class="fs-16">Hps</div> <div class="fs-10">healthpurse</div></div><div><svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 16 16"><path fill="#91caf3" d="M3 9.5a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3m5 0a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3m5 0a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3"/></svg></div>
    </div>
    <div class="d-flex justify-content-center align-items-center"> 
        <!-- <div class="outer d-flex justify-content-center align-items-center">  -->
        <!-- <div class="inner d-flex justify-content-center align-items-center">12</div>  -->
        
        <style>
  @keyframes progress {
    from {
      stroke-dasharray: 0 1400;
    }
    to {
      stroke-dasharray: 1257 1400;
    }
  }

  .progress {
    animation: progress 2s linear infinite;
    animation-direction: alternate;
  }
</style>
      
<svg viewBox="0 0 800 800" xmlns="http://www.w3.org/2000/svg">
  <circle class="progress" cx="400" cy="400" fill="none"
    r="200" stroke-width="50" stroke="#0075c9"
    stroke-dasharray="700 1400"
    stroke-linecap="round" />
</svg> 
<!-- </div> -->
 </div>
    <div class="options d-flex justify-content-start align-items-center gap-4 p-2"><div><svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 24 24"><g fill="none" stroke="grey" stroke-linejoin="round" stroke-width="1.5"><path d="m2 6l6.913 3.917c2.549 1.444 3.625 1.444 6.174 0L22 6"/><path d="M2.016 13.476c.065 3.065.098 4.598 1.229 5.733c1.131 1.136 2.705 1.175 5.854 1.254c1.94.05 3.862.05 5.802 0c3.149-.079 4.723-.118 5.854-1.254c1.131-1.135 1.164-2.668 1.23-5.733c.02-.986.02-1.966 0-2.952c-.066-3.065-.099-4.598-1.23-5.733c-1.131-1.136-2.705-1.175-5.854-1.254a115 115 0 0 0-5.802 0c-3.149.079-4.723.118-5.854 1.254c-1.131 1.135-1.164 2.668-1.23 5.733a69 69 0 0 0 0 2.952Z"/></g></svg></div><div>AllMails</div> </div>
    <div class="options  d-flex justify-content-start align-items-center gap-4 p-2 "><div><svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 48 48"><path fill="none" stroke="grey" stroke-linecap="round" stroke-linejoin="round" d="M11.275 13.707h25.45V39.94a3.56 3.56 0 0 1-3.56 3.56h-18.33a3.56 3.56 0 0 1-3.56-3.56zm19.678-6.138l-.89-3.069H17.937l-.89 3.069H9.328v6.138h29.344V7.569z" stroke-width="0.5"/></svg></div><div>Trash</div></div>
    <div class="options d-flex justify-content-start align-items-center gap-4 p-2 "><div><svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 24 24"><path fill="grey" d="m8.85 16.825l3.15-1.9l3.15 1.925l-.825-3.6l2.775-2.4l-3.65-.325l-1.45-3.4l-1.45 3.375l-3.65.325l2.775 2.425zm3.15-.723l-3.63 2.192q-.16.079-.297.064q-.136-.016-.265-.094q-.13-.08-.196-.226t-.012-.319l.966-4.11l-3.195-2.77q-.135-.11-.178-.263t.019-.293t.165-.23q.104-.087.28-.118l4.216-.368l1.644-3.892q.068-.165.196-.238T12 5.364t.288.073t.195.238l1.644 3.892l4.215.368q.177.03.281.119q.104.088.166.229q.061.14.018.293t-.178.263l-3.195 2.77l.966 4.11q.056.171-.011.318t-.197.226q-.128.08-.265.095q-.136.015-.296-.064zm0-3.852"/></svg></div><div>Favourite</div></div>
    <div class="options  d-flex justify-content-start align-items-center gap-4 p-2 "><div><svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 24 24"><g fill="none" stroke="grey" stroke-width="1.5"><path d="M3.275 15.296C2.425 14.192 2 13.639 2 12c0-1.64.425-2.191 1.275-3.296C4.972 6.5 7.818 4 12 4s7.028 2.5 8.725 4.704C21.575 9.81 22 10.361 22 12c0 1.64-.425 2.191-1.275 3.296C19.028 17.5 16.182 20 12 20s-7.028-2.5-8.725-4.704Z"/><path d="M15 12a3 3 0 1 1-6 0a3 3 0 0 1 6 0Z"/></g></svg></div><div>Viewed</div></div>
    <div class="options  d-flex justify-content-start align-items-center gap-4 p-2 "><div><svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 24 24"><g fill="none" stroke="grey" stroke-linecap="round" stroke-width="0.5"><path stroke-linejoin="round" d="M10.73 5.073A11 11 0 0 1 12 5c4.664 0 8.4 2.903 10 7a11.6 11.6 0 0 1-1.555 2.788M6.52 6.519C4.48 7.764 2.9 9.693 2 12c1.6 4.097 5.336 7 10 7a10.44 10.44 0 0 0 5.48-1.52m-7.6-7.6a3 3 0 1 0 4.243 4.243"/><path d="m4 4l16 16"/></g></svg></div><div>Unviewed</div></div>





</div>
<div class="middle-container d-flex flex-column justify-content-start align-items-center p-4 gap-2  ">  
     @for (item of allMailsArrayTemp; track $index) {
    <div class="notifications d-flex justify-content-around align-items-center" (click)="openEmail(item.id)" >
    <div class="viewwed-circle-text d-flex justify-content-center align-items-center fs-16 "> {{item?.receiver.charAt(0)  }} {{item?.receiver.charAt(1)}}  </div> <div class="d-flex flex-column justify-content-start  gap-2"><span class="fs-10 fw-500">{{item?.receiver.slice(0,5) }}</span> <span class="fs-10"> {{item?.subject.slice(0,29)}}...</span>  </div> <div>{{item?.time}} @if(item?.time<60){Minago} @else{Hourago} </div>
</div>}</div> 

@if(type==='welcome'){
<div class="right-container d-flex flex-column gap-4 p-4">

    <div style="width:  1440; height: 1283; color: red;">
     <p>123</p>
    </div>

    
<div class="d-flex align-items-center gap-4">  <div class="viewwed-circle-text d-flex justify-content-center align-items-center fs-16 ">{{mailInfoArray?.receiver.charAt(0)}} {{mailInfoArray?.receiver.charAt(1)}}</div>  <div class="fs-16 fw-500">{{mailInfoArray?.receiver}}</div> </div>
<!-- <div class="d-flex  content flex-column justify-content-center align-items-center gap-2 " > <div class="cicle"></div>   <div> <img src="../../../../../assets/gifs/undraw_welcoming_42an (1).png " width="200px" height="200px"> </div><div class="d-flex flex-column"> <span>Hi {{mailInfoArray?.receiver}} </span><span class="text">Welcome To Hps Portal Start Your Journey  </span></div> <div><button class="primaryBtn" (click)="renerRespective(mailInfoArray?.link)"  > Please Set Your Password </button>  {{mailInfoArray?.message}}</div> </div> -->
<div class="image-curve"> <img src="../../../../../assets/gifs/cover.png"> <div class="middle-box d-flex justify-content-center gap-2"> <p class="text d-flex flex-column gap-2  align-items-center"> <span>Hi {{mailInfoArray?.receiver}}</span> <span>Welcome to Hps Website </span><span>Your Account Created Succesfully</span> </p>    <svg width="100%" height="100%" aspectratio="null" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    
<path d="M285.195 230.745C285.195 357.717 241.747 308.426 161.221 308.426C80.6957 308.426 0.195358 357.717 0.195358 230.745C0.195358 103.773 65.4743 0.842285 146 0.842285C226.526 0.842285 285.195 103.773 285.195 230.745Z" fill="#BBDEFB"/>
</svg>
<button class="btn">Reset Password</button>
  </div> <div class="welcome-feature d-flex gap-3"> <p class="features d-flex justify-content-between gap-2 p-2  align-items-center">   <span style="color: white; font-size: 12px; ">Work with uk professionals </span> </p> <p class="features d-flex justify-content-center p-2 align-items-center"> <span style="color: white; font-size: 12px; ">Pre Existeing Medical Cover</span></p> <p class="features p-2 d-flex justify-content-center align-items-center"> <span style="color: white; font-size: 12px; ">Life Insurance Protection </span></p> <p class="features  p-2 d-flex justify-content-around align-items-center"> <span style="color: white; font-size: 12px; ">Affordable Premiums </span></p></div>  </div>
  


</div>
}
@else if(type==='otp'){
  <div class="right-container d-flex flex-column gap-4 p-4">
    <div class="d-flex align-items-center gap-4">  <div class="viewwed-circle-text d-flex justify-content-center align-items-center fs-16 ">{{mailInfoArray?.receiver.charAt(0)}} {{mailInfoArray?.receiver.charAt(1)}}</div>  <div class="fs-16 fw-500">{{mailInfoArray?.receiver}}</div> </div>
     <div class="image-curve1">
        <div class="upper-design">
  <svg width="713" height="187" viewBox="0 0 713 187" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_9_27)">
<path d="M356.5 187C261.95 187 171.273 177.149 104.416 159.614C37.5597 142.08 0 118.298 0 93.5L0 0H713V93.5C713 118.298 675.44 142.08 608.584 159.614C541.727 177.149 451.05 187 356.5 187Z" fill="#8686FC"/>
</g>
<defs>
<clipPath id="clip0_9_27">
<rect width="713" height="187" fill="white"/>
</clipPath>
</defs>

</svg>
<p class="upper-heading d-flex flex-column justify-content-center  gap-3  ">
    <span class="fs-16 fw-500">Multi Factor Authentication</span>
 <span  > Hi {{mailInfoArray?.receiver}}, </span> 
 <span  >This is your One-Time Passcode (OTP) for login. </span>

</p>





        </div>

        <div class="otp-box d-flex flex-column justify-content-center gap-2 align-items-center"><p class="otp-text d-flex justify-content-center align-items-center gap-2"  >


            <span class="copy-icon" (click)="copyToClipboard(mailInfoArray?.message);$event.stopPropagation()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                        <path fill="#1976d2"
                            d="M16 1H4a2 2 0 0 0-2 2v14h2V3h12zm3 4H8a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2m0 16H8V7h11z" />
                    </svg>
                </span>
                <span *ngIf="copiedEmail === dbmessage" class="copied-text"
                    style="margin-left:6px; color: #43a047; font-size: 0.85em;">
                    Copied!
                </span>
            
            <span> {{mailInfoArray?.message.charAt(0)}}</span>            <span> {{mailInfoArray?.message.charAt(1)}}</span>
                        <span> {{mailInfoArray?.message.charAt(2)}}</span>
                                    <span> {{mailInfoArray?.message.charAt(3)}}</span>
                                                <span> {{mailInfoArray?.message.charAt(4)}}</span>
                                                            <span> {{mailInfoArray?.message.charAt(5)}}</span>





        </p> <p>This one-time passcode is valid for next 5 minutes only</p></div>
        
        
        <div class="diya-left"><svg width="120" height="120" viewBox="0 0 225 225" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_8_7)">
<path d="M225 112.5C225 134.75 218.402 156.501 206.04 175.002C193.679 193.502 176.109 207.922 155.552 216.436C134.995 224.951 112.375 227.179 90.5524 222.838C68.7295 218.497 48.6839 207.783 32.9505 192.049C17.2171 176.316 6.50253 156.27 2.16169 134.448C-2.17915 112.625 0.0487291 90.0047 8.56359 69.4481C17.0784 48.8914 31.4979 31.3213 49.9984 18.9596C68.4989 6.59796 90.2496 -4.57764e-05 112.5 -4.57764e-05L225 -4.57764e-05L225 112.5Z" fill="#8686FC"/>
</g>
<defs>
<clipPath id="clip0_8_7">
<rect width="225" height="225" fill="white" transform="matrix(0 -1 1 0 0 225)"/>
</clipPath>
</defs>
</svg>
</div> 

<div class="diya-right"><svg width="120" height="120" viewBox="0 0 225 225" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_8_7)">
<path d="M225 112.5C225 134.75 218.402 156.501 206.04 175.002C193.679 193.502 176.109 207.922 155.552 216.436C134.995 224.951 112.375 227.179 90.5524 222.838C68.7295 218.497 48.6839 207.783 32.9505 192.049C17.2171 176.316 6.50253 156.27 2.16169 134.448C-2.17915 112.625 0.0487291 90.0047 8.56359 69.4481C17.0784 48.8914 31.4979 31.3213 49.9984 18.9596C68.4989 6.59796 90.2496 -4.57764e-05 112.5 -4.57764e-05L225 -4.57764e-05L225 112.5Z" fill="#8686FC"/>
</g>
<defs>
<clipPath id="clip0_8_7">
<rect width="225" height="225" fill="white" transform="matrix(0 -1 1 0 0 225)"/>
</clipPath>
</defs>
</svg>
</div>

<div class="botton-curve">
    <svg width="713" height="102" viewBox="0 0 713 102" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_9_27)">
<path d="M356.5 1.90735e-06C451.05 1.90735e-06 541.727 5.3732 608.584 14.9376C675.44 24.5019 713 37.474 713 51V102H-1.14441e-05V51C-1.14441e-05 37.474 37.5597 24.5019 104.416 14.9376C171.273 5.3732 261.95 1.90735e-06 356.5 1.90735e-06Z" fill="#8686FC"/>
</g>
<defs>
<clipPath id="clip0_9_27">
<rect width="713" height="102" fill="white" transform="matrix(-1 0 0 -1 713 102)"/>
</clipPath>
</defs>
 <text 
    x="40" 
    y="60" 
    font-size="10" 
    fill="white" 
    stroke-width="1"
    font-weight="bold">
    Thank You,
    
    
  </text>
<text 
    x="40" 
    y="80" 
    font-size="10" 
    fill="white" 
    stroke-width="1"
    font-weight="bold">

    Health Pulse Service
  </text></svg>

</div>

</div>


  </div>}

</div>
